var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import cc from 'classcat';
import CalendarIcon from '../../../assets/icons/calendar-icon.svg';
import './calendar-button.style.scss';
/**
 * A button specifically for icons
 */
var CalendarButton = function (_a) {
    var onButtonClick = _a.onButtonClick, children = _a.children, className = _a.className, rest = __rest(_a, ["onButtonClick", "children", "className"]);
    return (React.createElement("button", __assign({ className: cc(['tfm-calendar-button', className]), type: "button", "aria-label": "\u0391\u03BD\u03BF\u03AF\u03BE\u03C4\u03B5 \u03C4\u03BF \u03B7\u03BC\u03B5\u03C1\u03BF\u03BB\u03CC\u03B3\u03B9\u03BF", onClick: onButtonClick }, rest),
        React.createElement(CalendarIcon, null)));
};
export default memo(CalendarButton);
